module.exports = __webpack_public_path__ + "media/images/pic/hero/woman-f38557cf10ec67e3e26ceed0478fd6af.webp";